import { useMemo, useState, useEffect } from "react";
import { Button, Box, Typography, Modal } from "@mui/material";
import { AiOutlineSearch } from "react-icons/ai";
import SearchBar from "../../common/SearchBar/SearchBar";
import SignIn from "../SignIn/SignIn";
import PropTypes from "prop-types";
import { useNavigate } from "react-router-dom";
import { jwtDecode } from "jwt-decode";
import styles from "./Promo.module.css";
import * as Sentry from "@sentry/react";

const Promo = ({ className = "" , handleSearch}) => {
  const [open, setOpen] = useState(false);
    const [isAuthenticated, setIsAuthenticated] = useState(false);
  const navigate = useNavigate();

  const boxSearch = (value) => {
    if (handleSearch) handleSearch(value);// Logs the search input value
  };


    useEffect(() => {
      const token = localStorage.getItem("authToken");
      if (token) {
        console.log(token)
        try {
          const { exp } = jwtDecode(token);
        console.log(exp)
        console.log(exp * 1000 > Date.now())
          if (exp && exp * 1000 > Date.now()) {
            setIsAuthenticated(true);
          } else {
            setIsAuthenticated(false);
          }
        } catch (err) {
        console.log(err)
          Sentry.captureException(err);
          setIsAuthenticated(false);
        }
      }
    }, []);

  const handleOpen = () => {
    if (!isAuthenticated) {
      setOpen(true);
    } else {
      navigate("/dashboard")
    }
  };

  const handleClose = () => setOpen(false);

  const handleSignInSuccess = () => {
    setOpen(false);
    window.location.href = "/dashboard";
  };

  return (
    <section className={[styles.promo, className].join(" ")}>
      <Box className={styles.ns11Wrapper}>
        <img className={styles.ns11Icon} alt="" src="/ns1-1@2x.png" />
      </Box>
      <Box className={styles.titleParent}>
        <Box className={styles.title}>
          <Typography
            className={styles.discoverCollectAContainer}
            variant="inherit"
            component="h1"
            sx={{ fontWeight: "800" }}
          >
            {/* <Typography className={styles.welcomeTo} variant="inherit">
              Welcome to
            </Typography>
            <Typography className={styles.mementoMaster} variant="inherit">
              {" "}
              Momento Master
            </Typography> */}
            <Typography className={styles.welcomeTo} variant="inherit">
              It starts
            </Typography>
            <Typography className={styles.mementoMaster} variant="inherit">
              {" "}
              with a moment.
            </Typography>
          </Typography>
          <Box className={styles.ourMarketplaceIsContainer}>
            {/* <Typography
              className={styles.welcomeTo}
              variant="inherit"
            >{`Empower your journey and share `}</Typography>
            <Typography className={styles.mementoMaster} variant="inherit">
              your moments with your fans
            </Typography> */}
            <Typography
              className={styles.welcomeTo}
              variant="inherit"
            >{`Your voice, your story, your truth.`}</Typography>
            <Typography className={styles.mementoMaster} variant="inherit">
              You inspire. You share.
            </Typography>
            <Typography className={styles.mementoMaster} variant="inherit">
              Let your community support you.
            </Typography>
          </Box>
        </Box>
        <Box className={styles.search}>
          <Button
            className={styles.startButton}
            disableElevation
            variant="contained"
            onClick={() => handleOpen()}
            sx={{
              textTransform: "none",
              color: "#fff",
              fontSize: "14",
              background: "#ff9500",
              borderRadius: "23px",
              "&:hover": { background: "#ff9500" },
              width: 98,
              height: 40,
            }}
          >
            Start now
          </Button>
          {/* <SearchBar icon={AiOutlineSearch} onSearch={boxSearch} placeholder="Search athletes, artists and creators" className={styles.searchBar} /> */}
        </Box>
      </Box>

      <Modal open={open} onClose={handleClose}>
        <Box className={styles.signInModal}>
          <SignIn onSignInSuccess={handleSignInSuccess} onClose={handleClose} create={false}/>
        </Box>
      </Modal>
    </section>
  );
};

Promo.propTypes = {
  className: PropTypes.string,
};

export default Promo;
